"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSceneObjectRepo = exports.SceneObjectsRepo = void 0;
const ObservableEntityRepo_1 = require("./ObservableEntityRepo");
class SceneObjectsRepo extends ObservableEntityRepo_1.ObservableEntityRepo {
}
exports.SceneObjectsRepo = SceneObjectsRepo;
function makeSceneObjectRepo() {
    return new SceneObjectsRepoImp();
}
exports.makeSceneObjectRepo = makeSceneObjectRepo;
class SceneObjectsRepoImp extends SceneObjectsRepo {
    constructor() {
        super(...arguments);
        this._pressedSceneObject = null;
        this._hoveredSceneObject = null;
    }
    get pressedSceneObject() {
        return this._pressedSceneObject;
    }
    set pressedSceneObject(sceneObjectId) {
        if (sceneObjectId === this._pressedSceneObject) {
            return;
        }
        this._pressedSceneObject = sceneObjectId;
        this.notify();
    }
    get hoveredSceneObject() {
        return this._hoveredSceneObject;
    }
    set hoveredSceneObject(sceneObjectId) {
        if (sceneObjectId === this._hoveredSceneObject) {
            return;
        }
        this._hoveredSceneObject = sceneObjectId;
        this.notify();
    }
}
